
const map_variant = async (data) => {
  const mappedData = await data.map((item, index) => {
    return ({
      key: item.id,
      bc_name: item.prod_name,
      bcSku: item.sku,
      prod_id: item.prod_id,
      type: item.bc_product_type,
      active: item.is_purchase,
      store: item.storename, // static as per your example
      enrichment: item.enrichment,  // every 5th is false
      lastUpdated: new Date(item.updated_at).toLocaleString("en-GB"), // format date
      action: item.variant_data ? "Edit" : "create",
      variant_data: item.variant_data,
      variant_options: item.variant_options,
      store_id: item.store_id,
      currency_symbol: item.currency_symbol,
      msrp: item.prod_msrp,
      sale_price: item.prod_sale_price,
      custom_fields: item.custom_fields_data,
      images: item.images,
      inventory_tracking: item.inventory_tracking,
      categories: item.categories,
      bc_url: item.bc_url,
      og_subscription_enabled:item.og_subscription_enabled
    })
  })
  return mappedData

}
const map_saplist = async (data) => {

  const mappedData = await data.map((item, index) => {
    let bcInventory = "NA", active = false, bc_product_sku = "NA", subscription = ""
    if (item.prdouct_data) {
      bcInventory = item.prdouct_data.inventory_level
      active = item.prdouct_data.is_purchase
      bc_product_sku = item.bc_product_sku
      subscription = item.is_subscription
    }
    if (item.variant_data && item.variant_data.id) {
      bcInventory = item.variant_data.inventory_level
      active = item.variant_data.is_purchase
      bc_product_sku = item.bc_product_sku
      subscription = item.variant_data.is_subscription
    }

    return ({
      prod_id: item.prod_id,
      key: item.id,
      bc_sku: item.bc_sku,
      sapSku: item.sap_sku,
      sapName: item.product_name,
      bc_name: item.prod_name,
      sapCustomerNumber: item.sap_customer_number,
      sapPrice: `${item.currency_symbol}${item.msrp_excl}`,
      sapMsrp: `${item.currency_symbol}${item.msrp_inc}`,
      availableStock: item.inventory_available,
      reservedStock: item.inventory_reserved,
      bcSku: bc_product_sku,
      type: item.is_bundle_prod ? "Bundle" : (item.prdouct_data ? item.prdouct_data.bc_product_type : (item.variant_data && item.variant_data.id ? "Variant" : "NA")),
      active: active,
      store: item.storename,
      bcInventory: bcInventory,
      enrichment: item.enrichment,
      lastUpdated: new Date(item.updated_at).toLocaleString("en-GB"), // format date
      action: item.prdouct_data || item.variant_data ? "Edit" : "create",
      variant_arr: item.variant_arr && item.variant_arr.length > 0 ? item.variant_arr : null,
      variant_data: item.variant_data && item.variant_data.id ? item.variant_data : null,
      variant_options: item.variant_options ? item.variant_options : null,
      prdouct_data: item.prdouct_data,
      store_id: item.store_id,
      currency_symbol: item.currency_symbol,
      custom_fields: item.custom_fields_data,
      images: item.images,
      categories: item.categories,
      modifier_data: item.modifier_data ? item.modifier_data : null,
      subscription: subscription ? "YES" : "NO",
      bc_url: item.bc_url,
      bundle_sap_Array: item.bundle_sap_Array ? item.bundle_sap_Array : [],
      og_subscription_enabled:item.og_subscription_enabled
    })
  })
  return mappedData

}
const map_simplelist = async (data) => {
  let mappedData = await data.map((item, index) => {
    let bcInventory = "NA"
    if (item.inventory_tracking !== "none") {
      bcInventory = item.inventory_level
    }
    let sap_sku = "NA", sapName = "NA", msrp_excl = "NA", msrp_inc = "NA", inventory_available = "NA", inventory_reserved = "NA"
    if (item.sap_data) {
      sap_sku = item.sap_data.sap_sku
      sapName = item.sap_data.sapName
      msrp_excl = item.sap_data.sap_msrp
      msrp_inc = item.sap_data.sap_sale
      inventory_available = item.sap_data.inventory_available
      inventory_reserved = item.sap_data.inventory_reserved
    }
    return ({
      prod_id: item.prod_id,
      bc_name: item.prod_name,
      key: item.id,
      sapSku: sap_sku,
      sapName: sapName,
      sapCustomerNumber: item.sap_customer_number,
      sapPrice: msrp_excl !== "NA" ? `${item.currency_symbol}${msrp_excl}` : "NA",
      sapMsrp: msrp_inc !== "NA" ? `${item.currency_symbol}${msrp_inc}` : "NA",
      availableStock: inventory_available,
      reservedStock: inventory_reserved,
      bcSku: item.sku,
      type: item.bc_product_type,
      active: item.is_purchase,
      store: item.storename, // static as per your example
      bcInventory: bcInventory,
      subscription: item.is_subscription ? "YES" : "NO", // static as per your example
      enrichment: item.enrichment,  // every 5th is false
      lastUpdated: new Date(item.updated_at).toLocaleString("en-GB"), // format date
      store_id: item.store_id,
      currency_symbol: item.currency_symbol,
      prdouct_data: {
        prod_msrp: `${item.prod_msrp}`,
        prod_sale_price: `${item.prod_sale_price}`,
        categories: item.categories,
        images: item.images,
        custom_fields: item.custom_fields_data,
        product_id: item.prod_id
      },
      bc_url: item.bc_url,
      og_subscription_enabled:item.og_subscription_enabled
    })
  })
  return mappedData
}
const map_bundleList = async (data) => {
  const mappedData = await data.map((item, index) => {

    return ({
      key: item.id,
      prod_id: item.prod_id,
      sapSku: item.sap_data ? item.sap_data.sap_sku : "NA",
      sapName: item.sap_data ? item.sap_data.sapName : "NA",
      sapCustomerNumber: item.sap_data ? item.sap_customer_number : "NA",
      sapPrice: item.sap_data ? `${item.currency_symbol}${item.sap_data.sap_msrp}` : "NA",
      sapMsrp: item.sap_data ? `${item.currency_symbol}${item.sap_data.sap_sale}` : "NA",
      availableStock: item.sap_data ? item.sap_data.inventory_available : "NA",
      reservedStock: item.sap_data ? item.sap_data.inventory_reserved : "NA",
      bcSku: item.sku,
      bc_name: item.prod_name,
      type: item.bc_product_type,
      active: item.is_purchase,
      store: item.storename, // static as per your example
      bcInventory: item.inventory_level,
      subscription: "Yes", // static as per your example
      enrichment: item.enrichment,  // every 5th is false
      lastUpdated: new Date(item.updated_at).toLocaleString("en-GB"), // format date
      action: item.prdouct_data || item.variant_data ? "Edit" : "create",
      config: item.modifier_data.config,
      modifier_data: item.modifier_data,
      msrp: item.prod_msrp,
      sale_price: item.prod_sale_price,
      currency_symbol: item.currency_symbol,
      custom_fields: item.custom_fields_data,
      categories: item.categories,
      images: item.images,
      store_id: item.store_id,
      bc_url: item.bc_url
    })
  })
  return mappedData
}
const map_kitList = async (data) => {
  const mappedData = await data.map((item, index) => ({
    key: item.id,
    kitname: item.prod_name,
    msrp: item.prod_msrp,
    sale_price: item.prod_sale_price,
    bcSku: item.sku,
    enrichment: item.enrichment,
    lastUpdated: new Date(item.updated_at).toLocaleString("en-GB"),
    action: item.is_published ? "Edit" : "Create",
    store: item.storename,
    active: item.status,
    bc_primary_sku: item.bc_primary_sku,
    bcPrimarySku: item.bc_primary_sku ? item.bc_primary_sku.value + ' - ' + item.bc_primary_sku.prod_name : '',
    bc_secondary_sku: item.bc_secondary_sku,
    discount: item.discount,
    select_kit_name: item.select_kit_name,
    custom_fields: item.custom_fields,
    prod_id: item.prod_id,
    store_id: item.store_id,
    updated_at: item.updated_at,
    is_published: item.is_published,
    kit_img_key: item.kit_img_key,
    images: item.images,
    categories: item.categories,
    currency_symbol: item.currency_symbol,
    bc_url: item.bc_url,
    intro_txt: item.intro_txt,
    multi_kit_prods: item.multi_kit_prods,
    is_multi_kit_prod: item.is_multi_kit_prod,
    is_kit_prod: item.is_kit_prod
  }))
  return mappedData
}

// sample product mapping
const map_sample_promotion_list = async (data) => {
  let mappedData = await data.map((item, index) => {
    let bcInventory = "NA"
    
    if (item.inventory_tracking !== "none") {
      bcInventory = item.inventory_level
    }
   
    return ({
      prod_id: item.prod_id,
      bcSku: item?.sku,
      bc_name: item.prod_name,
      key: item.id,
      type: item.bc_product_type,
      active: item.is_purchase,
      store: item.storename, // static as per your example
      bcInventory: bcInventory,
      lastUpdated: new Date(item.updated_at).toLocaleString("en-GB"), // format date
      store_id: item.store_id,
      currency_symbol: item.currency_symbol,
      is_bundle_prod: item.is_bundle_prod,
      is_kit_prod: item.is_kit_prod,
      is_multi_kit_prod: item.is_multi_kit_prod,
      is_candy_prod: item.is_candy_prod,
      is_sample_prod: item.is_sample_prod,
      prdouct_data: {
        prod_msrp: `${item.prod_msrp}`,
        prod_sale_price: `${item.prod_sale_price}`,
        categories: item.categories,
        images: item.images,
        custom_fields: item.custom_fields_data,
        product_id: item.prod_id
      },
      bc_url: item.bc_url,
    })
  })
  return mappedData
}


export default {
  map_variant,
  map_saplist,
  map_simplelist,
  map_bundleList,
  map_kitList,
  map_sample_promotion_list
}